module.exports = __webpack_public_path__ + "img/newBack.cc6d53fc.jpg";